import axios from "axios";

import {
  CASES_API_URL,
  SELF_EVALUATIONS_API_URL,
  GAMES_API_URL,
  PLAYERS_API_URL,
  NOMINATIONS_API_URL,
  SCENARIOS_API_URL,
  ADMIN_GAMES_API_URL,
  ADMIN_GAMES_HISTORY_API_URL,
  ADMIN_SCENARIOS_API_URL,
  ADMIN_PLAYERS_GET_API_URL,
  ADMIN_PLAYERS_PATCH_API_URL,
  ADMIN_USERS_API_URL,
  ADMIN_PLAYERS_DELETE_API_URL,
  ADMIN_EMAIL_REPORT_LINK_API_URL,
  ADMIN_EMAIL_RETURN_LINK_API_URL,  
  ADMIN_EMAIL_FORGOT_PASSWORD_LINK_API_URL,
  ADMIN_CHANGE_PASSWORD_API_URL,
  COMMENTS_API_URL,
  SUGGESTIONS_API_URL,
  ADMIN_COMMENTS_API_URL,
  SURVEYS_API_URL,
  ADMIN_FACILITATOR_INSTRUCTIONS_API_URL,
  ADMIN_GAME_CASE_OPTIONS_API_URL,
  GAME_CASE_OPTIONS_API_URL,
  ADMIN_CHANGE_FACILITATOR_NAME_API_URL,
  ADMIN_NEWS_API_URL,
  ADMIN_NOTIFICATIONS_API_URL,
  FEEDBACK_API_URL,
  ADMIN_CASES_API_URL,
  ADMIN_RPS_CASES_API_URL,  
  ADMIN_CLONE_SCENARIO_API_URL,
  ADMIN_RPS_SCENARIOS_API_URL,
  RPS_CASES_API_URL,
  RPS_SCENARIOS_API_URL,
  RPS_CASE_CHOICES_API_URL,
  RPS_ANSWERS_API_URL,
  ADMIN_PARTNER_INVOICE_API_URL,  
  ADMIN_RPS_CASE_CHOICES_API_URL,
  ADMIN_SPEAKING_TURNS_API_URL,
  ADMIN_EDIT_RPS_SIMULATIONS_API_URL,
  ADMIN_EDIT_RPS_SCENARIOS_API_URL,
  ADMIN_EDIT_PHOTOS_RPS_SCENARIOS_API_URL,
  ADMIN_EDIT_PHOTOS_RPS_CASES_API_URL,  
  ADMIN_FEEDBACK_API_URL,
  TRANSLATE_API_URL,
  ADMIN_RPS_TEMPLATE_CATEGORIES_API_URL,
  ADMIN_RPS_TEMPLATE_CASES_API_URL,
  ADMIN_RPS_TEMPLATE_CASE_CHOICES_API_URL,
  ADMIN_RPS_SCENARIOS_TEMPLATES_API_URL,
  ADMIN_RPS_CASES_TEMPLATES_API_URL,
  ADMIN_RPS_CASE_CHOICES_TEMPLATES_API_URL,
  ACTION_PLAN_VOTES_API_URL,
  PLAYERS_PAUSE_REMOVE_API_URL,
} from "./config";

const queryString = require("query-string");

// ADMIN FUNCTIONS

export function emailReportLink(gameCode, playerId, locale, reportingUrl, reportToSlack) {
  // Requests backend to email report to this player

  const headers = generateHeaders(gameCode);

  const Url = ADMIN_EMAIL_REPORT_LINK_API_URL + playerId;

  const params = {
    locale: locale,
    reporting_url: reportingUrl,
    report_to_slack: reportToSlack
  };

  return axios.post(Url, params, { headers: headers }).then(resp => resp.data);
}

export function emailReturnLink(gameCode, playerId, locale, returnUrl) {
  // Requests backend to email returning link to this player

  const headers = generateHeaders(gameCode);

  const Url = ADMIN_EMAIL_RETURN_LINK_API_URL + playerId;

  const params = {
    locale: locale,
    return_url: returnUrl
  };

  return axios.post(Url, params, { headers: headers }).then(resp => resp.data);
}

export async function createGame(
  gameName,
  additional_information,
  locale,
  scenario_id,
  rps_scenario_id,
  demo,
  demo_reason,
  enable_comments,
  enable_survey,
  survey_scale,
  enable_billing,
  practice,
  simulation_type,
  enable_suggestions,
  selected_cases = null
) {
  const params = {
    name: gameName,
    additional_information: additional_information,
    default_locale: locale,
    scenario_id: scenario_id,
    rps_scenario_id: rps_scenario_id,
    demo: demo,
    demo_reason: demo_reason,
    enable_comments: enable_comments,
    enable_survey: enable_survey,
    survey_scale: survey_scale,
    enable_billing: enable_billing,
    practice: practice,
    simulation_type: simulation_type,
    enable_suggestions: enable_suggestions,
    selected_cases: selected_cases
  };

  return axios.post(ADMIN_GAMES_API_URL, params).then(resp => resp.data);
}

export function getThisAdminInformation() {
  return axios.get(ADMIN_USERS_API_URL + "me").then(resp => resp.data);
}

export function getAllGames() {
  return axios
    .get(ADMIN_GAMES_API_URL)
    .then(resp => resp.data);
}

export function getGamesPaged(page, perPage) {
  return axios
    .get(ADMIN_GAMES_API_URL + "?rowsPerPage=" + perPage + "&pageNumber=" + page)
    .then(resp => resp.data);
}

export function getGamesHistoryPaged(page, perPage) {
  return axios
    .get(ADMIN_GAMES_HISTORY_API_URL + "?rowsPerPage=" + perPage + "&pageNumber=" + page)
    .then(resp => resp.data);
}

export function getGame(id) {
  return axios.get(ADMIN_GAMES_API_URL + id).then(resp => resp.data);
}

export function getFacilitatorInstructions() {
  return axios.get(ADMIN_FACILITATOR_INSTRUCTIONS_API_URL).then(resp => resp.data);
}

export function getNews() {
  return axios.get(ADMIN_NEWS_API_URL).then(resp => resp.data);
}

export function getNotifications() {
  return axios.get(ADMIN_NOTIFICATIONS_API_URL).then(resp => resp.data);
}

export function getScenarios() {
  return axios.get(ADMIN_SCENARIOS_API_URL).then(resp => resp.data);
}

export function getRPSScenarios(onlyEditable = false) {
  const url = ADMIN_RPS_SCENARIOS_API_URL + "?only_editable=" + onlyEditable

  return axios.get(url).then(resp => resp.data);
}

export function getRPSScenario(id) {
  return axios.get(ADMIN_RPS_SCENARIOS_API_URL + "?rps_scenario_id=" + id);
}


export function getPlayerByFacilitatorId(gameCode, facilitatorId) {
  const headers = generateHeaders(gameCode);
  const queryUrl = ADMIN_PLAYERS_GET_API_URL + facilitatorId;

  return axios.get(queryUrl, { headers: headers }).then(resp => resp.data);
}

export function getScenarioByIdAndLocale(id, default_locale) {
  const queryUrl =
    ADMIN_SCENARIOS_API_URL +
    "?" +
    queryString.stringify({ scenario_id: id, default_locale: default_locale });
  return axios.get(queryUrl).then(resp => resp.data);
}

export function updatePlayerData(playerId, gameCode, firstName, lastName, nickName, email) {
  const headers = generateHeaders(gameCode);

  return axios
    .patch(
      ADMIN_PLAYERS_PATCH_API_URL + playerId,
      {
        first_name: firstName,
        last_name: lastName,
        nick_name: nickName,
        email: email
      },
      { headers: headers }
    )
    .then(resp => resp.data);
}

export function deletePlayer(playerId, gameCode) {
  const headers = generateHeaders(gameCode);

  return axios
    .delete(ADMIN_PLAYERS_DELETE_API_URL + playerId, { headers: headers })
    .then(resp => resp.data);
}

export function updatePlayerPaused(playerId, paused, gameCode) {
  const headers = generateHeaders(gameCode);

  return axios
    .patch(
      ADMIN_PLAYERS_PATCH_API_URL + playerId,
      {
        paused: paused
      },
      { headers: headers }
    )
    .then(resp => resp.data);
}

export function updateGameOpen(gameId, gameCode, open) {
  const headers = generateHeaders(gameCode);

  return axios
    .patch(
      ADMIN_GAMES_API_URL + gameId,
      {
        open: open
      },
      { headers: headers }
    )
    .then(resp => resp.data);
}

export function updateGameLastPageShown(gameId, gameCode, last_page_shown) {
  const headers = generateHeaders(gameCode);
  return axios
    .patch(
      ADMIN_GAMES_API_URL + gameId,
      {
        last_page_shown: last_page_shown
      },
      { headers: headers }
    )
    .then(resp => resp.data);
}

export function updateGameInvoiced(gameId, gameCode, invoiced) {
  const headers = generateHeaders(gameCode);

  return axios
    .patch(
      ADMIN_GAMES_API_URL + gameId,
      {
        invoiced: invoiced
      },
      { headers: headers }
    )
    .then(resp => resp.data);
}

export function updateGameInvoicedPartner(gameId, invoiced) {
  return axios
    .patch(
      ADMIN_PARTNER_INVOICE_API_URL + gameId,
      {
        invoiced: invoiced
      },
    )
    .then(resp => resp.data);
}


export function updateGameSmoothTeamInvoiced(gameId, gameCode, smoothteam_invoiced) {
  const headers = generateHeaders(gameCode);

  return axios
    .patch(
      ADMIN_GAMES_API_URL + gameId,
      {
        smoothteam_invoiced: smoothteam_invoiced
      },
      { headers: headers }
    )
    .then(resp => resp.data);
}

export function updateGameReportingOpen(gameId, gameCode, reportingOpen, playersCount) {
  const headers = generateHeaders(gameCode);

  return axios
    .patch(
      ADMIN_GAMES_API_URL + gameId,
      {
        reporting_open: reportingOpen,
        players_count: playersCount
      },
      { headers: headers }
    )
    .then(resp => resp.data);
}

export function updateGameActionPlanActivated(gameId, gameCode, actionPlanActivated) {
  const headers = generateHeaders(gameCode);

  return axios
    .patch(
      ADMIN_GAMES_API_URL + gameId,
      {
        action_plan_activated: actionPlanActivated,
      },
      { headers: headers }
    )
    .then(resp => resp.data);
}

export function updateGameActionPlanVotingFinished(gameId, gameCode, finished) {
  const headers = generateHeaders(gameCode);

  return axios
    .patch(
      ADMIN_GAMES_API_URL + gameId,
      {
        action_plan_voting_finished: finished,
      },
      { headers: headers }
    )
    .then(resp => resp.data);
}

export function updateGameActionPlanLocked(gameId, gameCode, locked) {
  const headers = generateHeaders(gameCode);

  return axios
    .patch(
      ADMIN_GAMES_API_URL + gameId,
      {
        action_plan_locked: locked,
      },
      { headers: headers }
    )
    .then(resp => resp.data);
}

export function updateGameActionPlanEndVoting(gameId, gameCode, caseNumber) {
  const headers = generateHeaders(gameCode);

  return axios
    .patch(
      ADMIN_GAMES_API_URL + gameId,
      {
        action_plan_voting_finished: true,
        action_plan_case_being_discussed: caseNumber,
      },
      { headers: headers }
    )
    .then(resp => resp.data);
}

export function updateGameActionPlanCaseBeingDiscussed(gameId, gameCode, caseNumber) {
  const headers = generateHeaders(gameCode);

  return axios
    .patch(
      ADMIN_GAMES_API_URL + gameId,
      {

        action_plan_case_being_discussed: caseNumber,
      },
      { headers: headers }
    )
    .then(resp => resp.data);
}

export function updateGameActionPlanShowDevelopmentIdeas(gameId, gameCode, showDevelopmentIdeas) {
  const headers = generateHeaders(gameCode);

  return axios
    .patch(
      ADMIN_GAMES_API_URL + gameId,
      {
        action_plan_show_development_ideas: showDevelopmentIdeas,
      },
      { headers: headers }
    )
    .then(resp => resp.data);
}


export function updateGameInfo(gameId, gameCode, name, additional_information) {
  const headers = generateHeaders(gameCode);

  return axios
    .patch(
      ADMIN_GAMES_API_URL + gameId,
      {
        name: name,
        additional_information: additional_information
      },
      { headers: headers }
    )
    .then(resp => resp.data);
}

export function updateGameCurrentCaseNumberForPlayers(
  gameId,
  gameCode,
  current_case_number_for_players
) {
  const headers = generateHeaders(gameCode);

  return axios
    .patch(
      ADMIN_GAMES_API_URL + gameId,
      {
        current_case_number_for_players: current_case_number_for_players
      },
      { headers: headers }
    )
    .then(resp => resp.data);
}

export function createGameCaseOptions(gameId, caseId, gameCode, show_survey_questions) {
  const headers = generateHeaders(gameCode);

  return axios
    .put(
      ADMIN_GAME_CASE_OPTIONS_API_URL + "games/" + gameId + "/cases/" + caseId,
      {
        show_survey_questions: show_survey_questions
      },
      { headers: headers }
    )
    .then(resp => resp.data);
}

export function forgotPassword(email, locale, changePasswordUrl) {
  // Requests backend to email password change request to this player

  const Url = ADMIN_EMAIL_FORGOT_PASSWORD_LINK_API_URL + email;

  const params = {
    locale: locale,
    change_password_url: changePasswordUrl
  };

  return axios.post(Url, params).then(resp => resp.data);
}

export function changePassword(email, token, password) {
  // Requests backend to change password

  const Url = ADMIN_CHANGE_PASSWORD_API_URL + email;

  const params = {
    token: token,
    password: password
  };

  return axios.post(Url, params).then(resp => resp.data);
}

export function changeFacilitatorName(firstName, lastName) {
  const Url = ADMIN_CHANGE_FACILITATOR_NAME_API_URL;

  const params = {
    first_name: firstName,
    last_name: lastName
  };

  return axios.post(Url, params).then(resp => resp.data);
}

export function changeGameName(gameId, gameCode, gameName) {
  const headers = generateHeaders(gameCode);

  return axios
    .patch(
      ADMIN_GAMES_API_URL + gameId,
      {
        name: gameName
      },
      { headers: headers }
    )
    .then(resp => resp.data);
}

export function getAndCommitCommentsByGame(game, gameCode, commit) {
  const headers = generateHeaders(gameCode);

  const queryUrl = ADMIN_COMMENTS_API_URL + "games/" + game;

  return axios.get(queryUrl, { headers: headers }).then(resp => {
    commit({
      type: "setComments",
      comments: resp.data
    });

    return resp.data;
  });
}

export function getCases(scenario) {
  const caseQueryUrl = ADMIN_CASES_API_URL + "?scenario=" + scenario;

  return axios.get(caseQueryUrl);
}

export function getRPSCases(rps_scenario) {
  const rpsCaseQueryUrl = ADMIN_RPS_CASES_API_URL + "?rps_scenario=" + rps_scenario;

  return axios.get(rpsCaseQueryUrl);
}

export function getRPSCaseChoices(rps_scenario) {
  const rpsCaseQueryUrl = ADMIN_RPS_CASE_CHOICES_API_URL + "?rps_scenario=" + rps_scenario;
  return axios.get(rpsCaseQueryUrl);
}

export function cloneScenario(scenario, customCases) {
  const scenarioCloneUrl = ADMIN_CLONE_SCENARIO_API_URL + scenario + "/clone";
  return axios({
    method: "post",
    url: scenarioCloneUrl,
    data: customCases
  }).then(resp => resp.data);
}

export function getAndCommitSpeakingTurns(gameCode, game, commit) {
  const speakingTurnsQueryUrl = ADMIN_SPEAKING_TURNS_API_URL + "games/" + game
  const headers = generateHeaders(gameCode);

  return axios.get(speakingTurnsQueryUrl, { headers: headers }).then(resp => {
    if (resp.status === 200) {
      commit({
        type: "setSpeakingTurns",
        speakingTurns: resp.data
      });

      return resp.data;
    } else {
      // Should never get here...
      throw "Can't find speakingTurns for " + game;
    }
  });
}

export function sendSpeakingTurn(game, playerId, caseNumber, gameCode, hasSpoken, firstSpeakingTurn) {
  const headers = generateHeaders(gameCode);

  // Let's use PUT because player can change her mind.
  const putUrl = ADMIN_SPEAKING_TURNS_API_URL + "games/" + game + "/players/" + playerId + "/casenumbers/" + caseNumber;

  return axios
    .put(
      putUrl,
      {
        has_spoken: hasSpoken,
        first_speaking_turn: firstSpeakingTurn,
      },
      { headers: headers }
    )
    .then(resp => resp.data);
}

// Editing functions

export function editRPSScenario(simulation) {
  const putUrl = ADMIN_EDIT_RPS_SIMULATIONS_API_URL
  return axios
    .put(
      putUrl,
      simulation
    )
    .then(resp => resp.data);
}

export function updateRPSScenarioDraft(rpsScenarioId, draft) {
  return axios
    .patch(
      ADMIN_EDIT_RPS_SCENARIOS_API_URL + rpsScenarioId,
      {
        draft: draft,
      }
    )
    .then(resp => resp.data);
}

export function sendScenarioPhoto(rpsScenarioId, photoType, file) {
  // https://stackoverflow.com/a/43014086/76535  
  const formData = new FormData();
  formData.append("type", photoType);
  formData.append("image", file);

  return axios
    .patch(
      ADMIN_EDIT_PHOTOS_RPS_SCENARIOS_API_URL + rpsScenarioId,
      formData,
      { headers:
        {
          'Content-Type': 'multipart/form-data',
        }
      }
    )
    .then(resp => resp.data);
}

export function sendCasePhoto(rpsScenarioId, caseNumber, file) {
  // https://stackoverflow.com/a/43014086/76535  
  const formData = new FormData();
  formData.append("image", file);

  const URL = ADMIN_EDIT_PHOTOS_RPS_CASES_API_URL + rpsScenarioId + "/cases/" + caseNumber

  return axios
    .patch(
      URL,
      formData,
      { headers:
      {
        'Content-Type': 'multipart/form-data',
      }
    }
    )
    .then(resp => resp.data);
}

export function sendFacilitatorFeedback(openFeedback, facilitation, gameId, gameCode, locale) {
  const headers = generateHeaders(gameCode);

  return axios
    .post(
      ADMIN_FEEDBACK_API_URL + "games/" + gameId,
      {
        open_feedback: openFeedback,
        facilitation: facilitation,
        locale: locale
      },
      { headers: headers }
    )
    .then(resp => resp.data);
}

export function getRPSTemplateCategories() {
  return axios.get(ADMIN_RPS_TEMPLATE_CATEGORIES_API_URL);
}

export function getRPSTemplateCases() {
  return axios.get(ADMIN_RPS_TEMPLATE_CASES_API_URL);
}

export function getRPSTemplateCaseChoices() {
  return axios.get(ADMIN_RPS_TEMPLATE_CASE_CHOICES_API_URL);
}

export function getRPSScenariosTemplates() {
  return axios.get(ADMIN_RPS_SCENARIOS_TEMPLATES_API_URL);
}

export function getRPSCasesTemplates() {
  return axios.get(ADMIN_RPS_CASES_TEMPLATES_API_URL);
}

export function getRPSCaseChoicesTemplates() {
  return axios.get(ADMIN_RPS_CASE_CHOICES_TEMPLATES_API_URL);
}

export function getUsersForCompany() {
  return axios.get(ADMIN_USERS_API_URL).then(resp => resp.data);
}
///////////////////
// PLAYER FUNCTIONS

export function getSurveyAverage(game, aCase, surveyNumber, gameCode) {
  const queryUrl =
    SURVEYS_API_URL + "average/games/" + game + "/cases/" + aCase + "/survey/" + surveyNumber;
  const headers = generateHeaders(gameCode);

  return axios.get(queryUrl, { headers: headers }).then(resp => resp.data);
}

export function getGameByGameCode(gameCode) {
  // No need to authenticate
  const queryUrl = GAMES_API_URL + "?game_code=" + gameCode;

  return axios.get(queryUrl).then(resp => resp.data);
}

export function getFeedbackByGameCode(gameCode) {
  const queryUrl = ADMIN_FEEDBACK_API_URL + "?game_code=" + gameCode;

  const headers = generateHeaders(gameCode);

  return axios.get(queryUrl, { headers: headers }).then(resp => resp.data);
}

export function getGameByReportingCode(reportingCode) {
  // No need to authenticate
  const queryUrl = GAMES_API_URL + "?reporting_code=" + reportingCode;

  return axios.get(queryUrl).then(resp => resp.data);
}

export function getAndCommitGameByGameCodeAndPlayerId(gameCode, playerId, commit) {
  const qString = queryString.stringify({ game_code: gameCode, player: playerId });

  const queryUrl = GAMES_API_URL + "?" + qString;

  return axios.get(queryUrl).then(resp => {
    commit({
      type: "setGame",
      id: resp.data.id,
      name: resp.data.name,
      scenario: resp.data.scenario,
      defaultLocale: resp.data.default_locale,
      open: resp.data.open,
      reportingOpen: resp.data.reporting_open,
      opened: resp.data.opened,
      enableComments: resp.data.enable_comments,
      enableSurvey: resp.data.enable_survey,
      surveyScale: resp.data.survey_scale,
      demo: resp.data.demo,
      currentCaseNumberForPlayers: resp.data.current_case_number_for_players,
      practice: resp.data.practice,
      showVideos: resp.data.show_videos,
      surveyAnswersCanBeChanged: resp.data.survey_answers_can_be_changed,
      simulationType: resp.data.simulation_type,
      rpsScenario: resp.data.rps_scenario,
      anonymizeRPSReport: resp.data.anonymize_rps_report,
      companyLogo: resp.data.company_logo,
      enableSuggestions: resp.data.enable_suggestions,
      actionPlanActivated: resp.data.action_plan_activated,
      actionPlanVotingFinished: resp.data.action_plan_voting_finished,
      actionPlanLocked: resp.data.action_plan_locked,
      actionPlanCaseBeingDiscussed: resp.data.action_plan_case_being_discussed,
      actionPlanShowDevelopmentIdeas: resp.data.action_plan_show_development_ideas,
    });

    return resp.data;
  });
}

export function getAndCommitGameByGameCode(gameCode, commit) {
  // No need to authenticate
  const queryUrl = GAMES_API_URL + "?game_code=" + gameCode;

  return axios.get(queryUrl).then(resp => {
    commit({
      type: "setGame",
      id: resp.data.id,
      name: resp.data.name,
      scenario: resp.data.scenario,
      defaultLocale: resp.data.default_locale,
      open: resp.data.open,
      reportingOpen: resp.data.reporting_open,
      opened: resp.data.opened,
      enableComments: resp.data.enable_comments,
      enableSurvey: resp.data.enable_survey,
      surveyScale: resp.data.survey_scale,
      demo: resp.data.demo,
      currentCaseNumberForPlayers: resp.data.current_case_number_for_players,
      practice: resp.data.practice,
      showVideos: resp.data.show_videos,
      surveyAnswersCanBeChanged: resp.data.survey_answers_can_be_changed,
      simulationType: resp.data.simulation_type,
      rpsScenario: resp.data.rps_scenario,
      anonymizeRPSReport: resp.data.anonymize_rps_report,      
      companyLogo: resp.data.company_logo,
      enableSuggestions: resp.data.enable_suggestions,
      actionPlanActivated: resp.data.action_plan_activated,
      actionPlanVotingFinished: resp.data.action_plan_voting_finished,
      actionPlanLocked: resp.data.action_plan_locked,
      actionPlanCaseBeingDiscussed: resp.data.action_plan_case_being_discussed,
      actionPlanShowDevelopmentIdeas: resp.data.action_plan_show_development_ideas,
    });

    return resp.data;
  });
}

function generateHeaders(gameCode) {
  const headers = {
    gamecode: gameCode
  };

  /*
  ...In order to prevent such attacks, both Nginx and Apache 2.4+ strip all headers containing
  underscores from incoming requests by default. Django's built-in development server now does
  the same. Django's development server is not recommended for production use, but matching
  the behavior of common production servers reduces the surface area for behavior changes during deployment.
  */
  return headers;
}

export function getAndCommitCases(scenario, gameCode, commit) {
  const caseQueryUrl = CASES_API_URL + "?scenario=" + scenario;
  const headers = generateHeaders(gameCode);

  const cases = [];

  return axios.get(caseQueryUrl, { headers: headers }).then(resp => {
    if (resp.status === 200) {
      if (resp.data.length === 0) {
        return cases;
      } else {
        resp.data.forEach(aCase => {
          const newCase = Object();
          newCase.caseNumber = aCase.case_number;
          newCase.case = aCase.case;
          newCase.title = aCase.title;
          newCase.description = aCase.description;
          newCase.selfEvaluationQuestion = aCase.self_evaluation_question;
          newCase.caseQuestion = aCase.case_question;
          newCase.locale = aCase.locale;
          newCase.photo = aCase.photo;
          newCase.shortName = aCase.short_name;
          newCase.facilitatorInstructions = aCase.facilitator_instructions;
          newCase.commentQuestion = aCase.comment_question;
          newCase.surveyQuestion1 = aCase.survey_question_1;
          newCase.surveyQuestion2 = aCase.survey_question_2;
          newCase.startVideo = aCase.start_video;
          cases.push(newCase);
        });

        commit({
          type: "setCases",
          cases: cases
        });

        return resp.data;
      }
    } else {
      // Should never get here...
      throw "Can't find cases for " + scenario;
    }
  });
}

export function getAndCommitRPSCases(rpsScenario, gameCode, commit) {
  const rpsCaseQueryUrl = RPS_CASES_API_URL + "?rps_scenario=" + rpsScenario;
  const headers = generateHeaders(gameCode);

  const rpsCases = [];

  return axios.get(rpsCaseQueryUrl, { headers: headers }).then(resp => {
    if (resp.status === 200) {
      if (resp.data.length === 0) {
        return rpsCases;
      } else {
        resp.data.forEach(aCase => {
          const newCase = Object();
          newCase.caseNumber = aCase.case_number;
          newCase.photo = aCase.photo;
          newCase.locale = aCase.locale;
          newCase.rpsCase = aCase.rps_case;
          newCase.title = aCase.title;
          newCase.description = aCase.description;
          newCase.caseQuestion = aCase.case_question;
          newCase.facilitatorInstructions = aCase.facilitator_instructions;
          newCase.descriptionAboveCases = aCase.description_above_cases
          newCase.descriptionBelowCases = aCase.description_below_cases
          rpsCases.push(newCase);
        });

        commit({
          type: "setRPSCases",
          rpsCases: rpsCases
        });

        return resp.data;
      }
    } else {
      // Should never get here...
      throw "Can't find rpsCases for " + rpsScenario;
    }
  });
}

export function getAndCommitRPSCaseChoices(rpsScenario, gameCode, commit) {
  const rpsCaseChoiceQueryUrl = RPS_CASE_CHOICES_API_URL + "?rps_scenario=" + rpsScenario;
  const headers = generateHeaders(gameCode);

  return axios.get(rpsCaseChoiceQueryUrl, { headers: headers }).then(resp => {
    if (resp.status === 200) {
      commit({
        type: "setRPSCaseChoices",
        rpsCaseChoices: resp.data
      });

      return resp.data;
    } else {
      // Should never get here...
      throw "Can't find rpsCases for " + rpsScenario;
    }
  });
}

export function getScenario(scenario, gameCode) {
  const scenarioQueryUrl = SCENARIOS_API_URL + scenario;
  const headers = generateHeaders(gameCode);
  return axios.get(scenarioQueryUrl, { headers: headers });
}

export function getAndCommitScenario(scenario, gameCode, commit) {
  const scenarioQueryUrl = SCENARIOS_API_URL + scenario;
  const headers = generateHeaders(gameCode);

  return axios.get(scenarioQueryUrl, { headers: headers }).then(resp => {
    if (resp.status === 200) {
      if (resp.data.length === 0) {
        console.log("Scenarios not found!?");
        return null;
      } else {
        commit({
          type: "setScenarios",
          scenarios: resp.data
        });

        return resp.data;
      }
    } else {
      // Should never get here...
      throw "Can't find scenario " + scenario;
    }
  });
}

export function getAndCommitRPSScenario(rpsScenario, gameCode, commit) {
  const rpsScenarioQueryUrl = RPS_SCENARIOS_API_URL + rpsScenario;
  const headers = generateHeaders(gameCode);

  return axios.get(rpsScenarioQueryUrl, { headers: headers }).then(resp => {
    if (resp.status === 200) {
      if (resp.data.length === 0) {
        console.log("Scenarios not found!?");
        return null;
      } else {
        commit({
          type: "setRPSScenarios",
          rpsScenarios: resp.data
        });

        return resp.data;
      }
    } else {
      // Should never get here...
      throw "Can't find rpsScenario " + rpsScenario;
    }
  });
}

export function createPlayer(
  firstName,
  lastName,
  nickName,
  email,
  gameId,
  gameCode,
  notificationConnected,
  robot = false
) {
  const headers = generateHeaders(gameCode);

  const params = {
    first_name: firstName,
    last_name: lastName,
    nick_name: nickName,
    email: email,
    game: gameId,
    paused: false,
    notification_connected: notificationConnected,
    robot: robot
  };

  return axios.post(PLAYERS_API_URL, params, { headers: headers }).then(resp => resp.data);
}

export function getPlayerByAllData(game, gameCode, email, first_name, last_name, nick_name) {
  // Used for checking if player already exists

  const headers = generateHeaders(gameCode);
  const qString = queryString.stringify({
    game: game,
    email: email,
    first_name: first_name,
    last_name: last_name,
    nick_name: nick_name
  });

  const queryUrl = PLAYERS_API_URL + "?" + qString;

  return axios.get(queryUrl, { headers: headers }).then(resp => resp.data);
}

export function getPlayerByNickname(game, gameCode, nick_name) {
  // Used for checking if nick is reserved

  const headers = generateHeaders(gameCode);
  const qString = queryString.stringify({ game: game, nick_name: nick_name });
  const queryUrl = PLAYERS_API_URL + "?" + qString;

  return axios.get(queryUrl, { headers: headers }).then(resp => resp.data);
}

export function getPlayerByEmail(game, gameCode, email) {
  // Used for checking if nick is reserved

  const headers = generateHeaders(gameCode);
  const qString = queryString.stringify({ game: game, email: email });
  const queryUrl = PLAYERS_API_URL + "?" + qString;

  return axios.get(queryUrl, { headers: headers }).then(resp => resp.data);
}

export function getPlayerByReportingCode(reportingCode) {
  const queryUrl = PLAYERS_API_URL + "?reporting_code=" + reportingCode;

  return axios.get(queryUrl).then(resp => resp.data);
}

export function getPlayerByReturnCode(gameCode, returnCode) {
  const headers = generateHeaders(gameCode);

  const queryUrl = PLAYERS_API_URL + "returncode/" + returnCode;

  return axios.get(queryUrl, { headers: headers }).then(resp => resp.data);
}

export function getAndCommitPlayersByGame(game, gameCode, commit) {
  const headers = generateHeaders(gameCode);

  const queryUrl = PLAYERS_API_URL + "?game=" + game;

  return axios.get(queryUrl, { headers: headers }).then(resp => {
    commit({
      type: "setAllPlayers",
      players: resp.data
    });

    return resp.data;
  });
}

export function getPlayersByGame(game, gameCode) {
  const headers = generateHeaders(gameCode);

  const queryUrl = PLAYERS_API_URL + "?game=" + game;

  return axios.get(queryUrl, { headers: headers });
}

export function getSelfEvaluationsByGame(game, gameCode) {
  const headers = generateHeaders(gameCode);

  const queryUrl = SELF_EVALUATIONS_API_URL + "games/" + game;

  return axios.get(queryUrl, { headers: headers });
}

export function getAndCommitSelfEvaluationsByGame(game, gameCode, commit) {
  const headers = generateHeaders(gameCode);

  const queryUrl = SELF_EVALUATIONS_API_URL + "games/" + game;

  return axios.get(queryUrl, { headers: headers }).then(resp => {
    commit({
      type: "setSelfEvaluations",
      selfEvaluations: resp.data
    });

    return resp.data;
  });
}

export function createSelfEvaluation(player, aCase, priority, isLastCase, gameCode) {
  const headers = generateHeaders(gameCode);

  return axios
    .put(
      SELF_EVALUATIONS_API_URL,
      {
        player: player,
        case: aCase,
        priority: priority,
        is_last_case: isLastCase
      },
      { headers: headers }
    )
    .then(resp => resp.data);
}

export function getAndCommitNominationsByGameAndCase(game, gameCode, aCase, commit) {
  // Nominations for one case only
  const headers = generateHeaders(gameCode);
  const queryUrl = NOMINATIONS_API_URL + "?game=" + game + "&case=" + aCase;

  return axios.get(queryUrl, { headers: headers }).then(resp => {
    commit({
      type: "mergeNominations",
      nominations: resp.data
    });
    return resp.data;
  });
}

export function getAndCommitNominationsByGame(game, gameCode, commit) {
  // All nominations for a game
  const headers = generateHeaders(gameCode);
  const queryUrl = NOMINATIONS_API_URL + "?game=" + game;

  return axios.get(queryUrl, { headers: headers }).then(resp => {
    commit({
      type: "setNominations",
      nominations: resp.data
    });
    return resp.data;
  });
}

export function sendNomination(game, player, nominee, aCase, gameCode) {
  const headers = generateHeaders(gameCode);

  // Let's use PUT because player can change her mind.
  const putUrl = NOMINATIONS_API_URL + "games/" + game + "/players/" + player + "/cases/" + aCase;

  return axios
    .put(
      putUrl,
      {
        nominee: nominee
      },
      { headers: headers }
    )
    .then(resp => resp.data);
}

export function sendRPSAnswer(game, player, gameCode, rpsCase, rpsCaseChoise) {
  const headers = generateHeaders(gameCode);

  // Let's use PUT because player can change her mind.
  const putUrl = RPS_ANSWERS_API_URL + "games/" + game + "/players/" + player + "/rpscases/" + rpsCase;

  return axios
    .put(
      putUrl,
      {
        rps_case_choice: rpsCaseChoise
      },
      { headers: headers }
    )
    .then(resp => resp.data);
}


export function getRPSAnswersByGame(game, gameCode) {
  // All rps answers for a game
  const headers = generateHeaders(gameCode);
  const queryUrl = RPS_ANSWERS_API_URL + "games/" + game;

  return axios.get(queryUrl, { headers: headers });
}


export function getAndCommitRPSAnswersByGame(game, gameCode, commit) {
  // All rps answers for a game
  const headers = generateHeaders(gameCode);
  const queryUrl = RPS_ANSWERS_API_URL + "games/" + game;

  return axios.get(queryUrl, { headers: headers }).then(resp => {
    commit({
      type: "setRPSAnswers",
      rpsAnswers: resp.data
    });
    return resp.data;
  });
}

export function getAndCommitSurveyAnswersByGame(game, gameCode, commit) {
  // All nominations for a game
  const headers = generateHeaders(gameCode);
  const queryUrl = SURVEYS_API_URL + "?game=" + game;

  return axios.get(queryUrl, { headers: headers }).then(resp => {
    commit({
      type: "setSurveyAnswers",
      surveyAnswers: resp.data
    });
    return resp.data;
  });
}

export function sendSurvey(game, player, aCase, surveyNumber, answer, gameCode) {
  const headers = generateHeaders(gameCode);

  // Let's use PUT because player can change her mind.
  const putUrl =
    SURVEYS_API_URL +
    "games/" +
    game +
    "/players/" +
    player +
    "/cases/" +
    aCase +
    "/survey/" +
    surveyNumber;

  return axios
    .put(
      putUrl,
      {
        answer: answer
      },
      { headers: headers }
    )
    .then(resp => resp.data);
}

export function sendComment(game, player, comment, aCase, gameCode) {
  const headers = generateHeaders(gameCode);

  const postUrl = COMMENTS_API_URL + "games/" + game + "/players/" + player + "/cases/" + aCase;

  return axios
    .post(
      postUrl,
      {
        comment: comment
      },
      { headers: headers }
    )
    .then(resp => resp.data);
}

export function sendSuggestion(game, player, suggestion, aCase, rpsCase, gameCode) {
  const headers = generateHeaders(gameCode);

  const postUrl = SUGGESTIONS_API_URL + "games/" + game;

  return axios
    .post(
      postUrl,
      {
        suggestion: suggestion,
        player: player,
        case: aCase,
        rps_case: rpsCase,
      },
      { headers: headers }
    )
    .then(resp => resp.data);
}

export function editSuggestion(id, suggestion, owner, deadline, gameCode) {
  const headers = generateHeaders(gameCode);

  const putUrl = SUGGESTIONS_API_URL + id;

  return axios
    .put(
      putUrl,
      {
        suggestion: suggestion,
        owner: owner,
        deadline: deadline,
      },
      { headers: headers }
    )
    .then(resp => resp.data);
}

export function deleteSuggestion(id, gameCode) {
  const headers = generateHeaders(gameCode);

  const deleteUrl = SUGGESTIONS_API_URL + id;

  return axios
    .delete(
      deleteUrl,
      { headers: headers }
    )
    .then(resp => resp.data);
}


export function sendActionPlanVote(game, player, aCase, rpsCase, gameCode) {
  const headers = generateHeaders(gameCode);

  const putUrl = ACTION_PLAN_VOTES_API_URL + "games/" + game + "/players/" + player;

  return axios
    .put(
      putUrl,
      {
        player: player,
        case: aCase,
        rps_case: rpsCase,
      },
      { headers: headers }
    )
    .then(resp => resp.data);
}

export function deleteActionPlanVote(id, gameCode) {
  const headers = generateHeaders(gameCode);

  const deleteUrl = ACTION_PLAN_VOTES_API_URL + id;

  return axios
    .delete(
      deleteUrl,
      { headers: headers }
    )
    .then(resp => resp.data);
}


export function getSuggestionsByGame(game, gameCode) {
  const headers = generateHeaders(gameCode);

  const queryUrl = SUGGESTIONS_API_URL + "games/" + game;

  return axios.get(queryUrl, { headers: headers });
}

export function getAndCommitSuggestionsByGame(game, gameCode, commit) {
  const headers = generateHeaders(gameCode);

  const queryUrl = SUGGESTIONS_API_URL + "games/" + game;

  return axios.get(queryUrl, { headers: headers }).then(resp => {
    commit({
      type: "setSuggestions",
      suggestions: resp.data
    });

    return resp.data;
  });
}

export function getAndCommitActionPlanVotesByGame(game, gameCode, commit) {
  const headers = generateHeaders(gameCode);

  const queryUrl = ACTION_PLAN_VOTES_API_URL + "games/" + game;

  return axios.get(queryUrl, { headers: headers }).then(resp => {
    commit({
      type: "setActionPlanVotes",
      action_plan_votes: resp.data
    });

    return resp.data;
  });
}

export function getAndCommitGameCaseOptionsByGame(game, gameCode, commit) {
  // All game case options for a game
  const headers = generateHeaders(gameCode);
  const queryUrl = GAME_CASE_OPTIONS_API_URL + "games/" + game;

  return axios.get(queryUrl, { headers: headers }).then(resp => {
    commit({
      type: "setGameCaseOptions",
      gameCaseOptions: resp.data
    });
    return resp.data;
  });
}

export function sendFeedback(learn, openFeedback, selected, gameId, gameCode, locale) {
  const headers = generateHeaders(gameCode);

  return axios
    .post(
      FEEDBACK_API_URL + "games/" + gameId,
      {
        what_did_i_learn: learn,
        open_feedback: openFeedback,
        nps_answer: selected,
        locale: locale
      },
      { headers: headers }
    )
    .then(resp => resp.data);
}


export function removePlayerPause(playerId, gameCode) {
  const headers = generateHeaders(gameCode);

  return axios
    .put(
      PLAYERS_PAUSE_REMOVE_API_URL,
      {
        player_id: playerId
      },
      { headers: headers }
    )
    .then(resp => resp.data);
}


// AMAZON TRANSLATE

export function translate(fromLocale, toLocale, text, sendToSlack = false) {
  return axios
    .post(
      TRANSLATE_API_URL,
      {
        from_locale: fromLocale,
        to_locale: toLocale,
        text: text,
        send_to_slack: sendToSlack,
      }
    )
}
